<template>
<!--:permanent="$vuetify.breakpoint.mdAndUp" -->
  <v-navigation-drawer clipped app v-model="drawer">
    <v-list dense nav>
      <v-list-item v-for="item in items" :key="item.title" link>
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: 'default-drawer', 
 data: () => ({ 
      eventId: null,
      timeout: 0,
      items: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard' },
          { title: 'Photos', icon: 'mdi-image' },
          { title: 'About', icon: 'mdi-help-box' },
        ],
        right: null
  }),
   methods: {
        ...mapActions("application", ["toggleLoading", "setError", "showDrawer"])
   },
  computed: {   
    drawer: {
      get() {
        return this.$store.state.application.drawer;
      },
      set(val) {
        this.showDrawer(val);
      }
    }
  }
};
</script>
